import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { date, validString } from "Components/shared/helpers/validations";

export const ParcelsPickupCreateSchema = Yup.object().shape(
  reverseShape({
    isEmptyPickup: Yup.boolean().required(),
    customerList: Yup.array().when("isEmptyPickup", {
      is: true,
      then: Yup.array().min(1).required(),
      otherwise: Yup.array().notRequired().nullable(),
    }),
    customerLocation: Yup.array().when("isEmptyPickup", {
      is: true,
      then: Yup.array().min(1).required(),
      otherwise: Yup.array().notRequired().nullable(),
    }),
    pickupDate: date.required(),
    pickupTimeFrom: validString.required(),
    pickupTimeTo: validString.required(),
    dropOffLocationID: Yup.string().required(),
    pickupInstructions: Yup.string().optional(),
  }),
);
